import Service, { service } from '@ember/service'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import {
  SUBSCRIPTION_TYPE_READING as READING,
  SUBSCRIPTION_TYPE_MATHS as MATHS,
} from 'teacher-ui-client/subscription-type/subscription-types'
import type SessionService from 'teacher-ui-client/services/session'
import type { PartnerCode } from 'teacher-ui-client/partner/partners'

export default class PartnerService extends Service {
  @service session!: SessionService

  // School partners and their associated partner should be loaded in application startup
  private get schoolPartners() {
    // This is a hasmany relationship proxy, needs ember get
    return this.session.currentSchool.get('schoolPartners')
  }

  partnerForSubscriptionType(subscriptionType: SubscriptionType) {
    return this.schoolPartners?.find((schoolPartner) => schoolPartner.subscriptionType === subscriptionType)?.partner
  }

  get readingPartner() {
    return this.partnerForSubscriptionType(READING)
  }

  get mathsPartner() {
    return this.partnerForSubscriptionType(MATHS)
  }

  hasPartner(partnerCode: PartnerCode, subscriptionType: SubscriptionType) {
    const partner = this.partnerForSubscriptionType(subscriptionType)
    return partner?.code === partnerCode
  }
}

declare module '@ember/service' {
  interface Registry {
    partner: PartnerService
  }
}
